import { Routes } from "@angular/router";
import { InviteComponent } from "src/app/invites/invite/invite.component";
import { InvitecontactsComponent } from "src/app/invites/invitecontacts/invitecontacts.component";
import { InvitefirmComponent } from "src/app/invites/invitefirm/invitefirm.component";
import { InvitesentComponent } from "src/app/invites/invitesent/invitesent.component";

export const INVITES_ROUTES: Routes = [
    {
        path: 'invite', component: InviteComponent
    },
    {
        path: 'invite/company', component: InvitefirmComponent
    },
    {
        path: 'invite/user', component: InvitecontactsComponent
    },
    {
        path: 'invite/sent', component: InvitesentComponent
    }
]